import React from 'react'
import classNames from 'classnames'
import { Button } from '@/ui/atoms/Button'

type FilterItemProps = {
  children: React.ReactNode
  onClick?: () => void
  isActive?: boolean
  disabled?: boolean
  className?: string
}

export const FilterItem: React.FC<FilterItemProps> = (props) => {
  const {
    isActive = false,
    children,
    onClick,
    disabled,
    className: classNameFromProps,
    ...restProps
  } = props

  return (
    <Button
      {...restProps}
      onClick={onClick}
      variant={'primary'}
      size={'sm'}
      disabled={disabled}
      className={classNames(classNameFromProps, {
        'bg-blue-20 text-text-inverted canhover:hover:opacity-85 !px-3': isActive,
        'bg-transparent text-text-base canhover:hover:bg-bg-intense-transparent-20 !px-3':
          !isActive,
      })}
    >
      {children}
    </Button>
  )
}
